import * as React from 'react';
import DatePicker from 'react-mobile-datepicker';
import request from '@/server/request';
import config from '@/server/config';
import * as utils from '@/server/utils';

export default class IntegralDetail extends React.Component<any, any> {
	private page: number = 1;
	private loadTimer: any;
    private dateAllBtn: HTMLElement;

	constructor(props: any) {
		super(props);
		let month: any = new Date().getMonth() + 1;
		if (month < 10) {
			month = '0' + month;
		}
		this.state = {
        	memberId: utils.getQueryString('mid') || '', // 会员id
        	dateConfig: {
			    'year': {
			        format: 'YYYY',
			        caption: 'Year',
			        step: 1,
			    },
			    'month': {
			        format: 'M',
			        caption: 'Mon',
			        step: 1,
			    },
			},
			dateVisible: false,
			dateValue: new Date(),
			dateYear: '',
			dateMonth: '',
			loading: true, // 是否加载中
            loadOver: false, // 是否加载完
            list: [],
            type: utils.getQueryString('type') || 1
        }
	}

	public componentDidMount() {

		this.getIntegralDetail();
		window.addEventListener('scroll', this.scrollAction.bind(this));
	}

	public componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollAction.bind(this));
        if (this.loadTimer) { 
            clearTimeout(this.loadTimer);
        }
        // 卸载异步操作设置状态
        this.setState = (state, callback) => {
            return;
        }
        if (this.dateAllBtn) {
            this.dateAllBtn.onclick = null;
            this.dateAllBtn.remove();
        }
        
        
    }

	public render() {
		return (
			<div className="integral-detail">
				<dl className="integral-filter">
					<dt onClick={this.openDate}>{this.state.dateYear ? (this.state.dateYear + '年' + this.state.dateMonth + '月') : '全部'}</dt>
				</dl>
				<ul className="integral-detail-list">
					{
						this.state.list.map((v: any) => {
							return (
								<li key={v.id}>
									<strong>{v.content}</strong>
									<p>
										<span>{v.createTime}</span>
										{v.score}
									</p>
								</li>
							)
						})
					}
					
				</ul>
                <p className="loading-tips">{this.state.loadOver ? '没有更多数据' : '数据加载中...'}</p>
				<DatePicker
				    dateConfig={this.state.dateConfig}
				    isOpen={this.state.dateVisible}
				    headerFormat={'YYYY年MM月'}
				    onCancel={this.closeDate}
				    onSelect={this.selectDate}
				    value={this.state.dateValue}
				/>
			</div>
		)
	}

	// 获取积分详情
    private async getIntegralDetail() {
        const data: any = {
            memberId: this.state.memberId,
            type: this.state.type
        };
        if (this.state.dateYear) {
            data.dateYearMonth = this.state.dateYear + '-' + this.state.dateMonth;
        }
        const r = await request({
            url: `${config.COMPONENT_API}score/record/list?pageNum=` + this.page + '&pageSize=20',
            method: 'post',
            data: JSON.stringify(data),
            headers: {
            	'Content-Type': 'application/json'
            }
        });

        if (r.code === 1) {
        	this.setState({
        		list: this.state.list.concat(r.obj.list),
        		loading: false,
                loadOver: r.obj.pageNum >= r.obj.pages
        	});
        }
    }

    // 打开日期选择
    private openDate = () => {
        // 手动添加时间弹层全部按钮
        this.addDateAllBtn();
    	this.setState({
    		dateVisible: true
    	});
    }

    // 关闭日期选择
    private closeDate = () => {
    	this.setState({
    		dateVisible: false
    	});
    }

    private selectDate = (dateInfo: any) => {
    	const date = new Date(dateInfo);
    	let month: any = date.getMonth() + 1;
		if (month < 10) {
			month = '0' + month;
		}
    	this.setState({
    		dateValue: dateInfo,
    		dateYear: date.getFullYear(),
    		dateMonth: month
    	}, () => {
    		this.reload();
    	});
    	this.closeDate();
    }

    /**
     * 加载更多
     * 滚动加载更多数据
     */
    private scrollAction() {
        if (this.state.loading || this.state.loadOver) { 
            return;
        }
        
        if (window.pageYOffset + window.innerHeight + 50 > document.body.scrollHeight) {
            if (this.loadTimer) { 
                clearTimeout(this.loadTimer);
            }
            this.loadTimer = setTimeout(() => {
                this.loadMore();
             }, 500);
        }
    }

    // 加载更多文章内容
    private loadMore() { 
    	this.page ++;
        this.setState({
            loading: true,
        }, () => { 
            this.getIntegralDetail();
        });
    }

    // 重新加载页面数据
    private reload() { 
    	this.page = 1;
        this.setState({
            list: [],
            loading: true,
            loadOver: false
        }, () => { 
            this.getIntegralDetail();
        });
    }

    private addDateAllBtn() {
        if (!this.dateAllBtn) {
            this.dateAllBtn = document.createElement('a');
            this.dateAllBtn.className = 'datepicker-navbar-btn';
            this.dateAllBtn.innerHTML = '全部';
            this.dateAllBtn.onclick = () => {
                this.setState({
                    dateValue: new Date(),
                    dateYear: '',
                    dateMonth: ''
                }, () => {
                    this.reload();
                });
                this.closeDate();
            };
        }
        (document as any).querySelector('.datepicker.default').querySelector('.datepicker-navbar').insertBefore(this.dateAllBtn, null);
    }
}